import React from 'react';
import styles from '../styles/components/TabHeaderElement.module.css';

export interface TabHeaderElementData {
  text: string;
  count: number;
  index: number;
  specialty?: string;
}
export const TabHeaderElement: React.FC<TabHeaderElementData> = ({
  text,
  count,
  specialty,
  index,
}) => (
  <div key={index} className={`${styles.tabHeaderElement}`}>
    <div>
      <span className={styles.tabHeaderPanelName}>{text}</span>
    </div>
    <div>
      {specialty ? (
        <span className={styles.tabHeaderText}>{specialty}</span>
      ) : (
        <span className={styles.tabHeaderText}>Panel Surveys</span>
      )}
      <span className={styles.tabHeaderPanelName}> </span>
      <span className={styles.tabSurveysCount}>{`(${count} Sendable)`}</span>
    </div>
  </div>
);
